import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/auth";
import messageReducer from "./slices/message";
import settingReducer from "./slices/setting";
import financeReducer from "./slices/finance";
import enquiryReducer from "./slices/enquiry";
import productReducer from "./slices/product";
import inventoryReducer from "./slices/inventory";
import challanReducer from "./slices/challan";
import  purchaseReducer from "./slices/purchase";
import  customerReducer from "./slices/customer";
import dealerReducer from "./slices/dealer";
import quoteReducer from "./slices/quote";
import demoReducer from "./slices/demo";
import countryReducer from "./slices/country";

const reducer = {
  auth: authReducer,
  message: messageReducer,
  setting: settingReducer,
  finance: financeReducer,
  enquiry: enquiryReducer,
  demo: demoReducer,
  customer: customerReducer,
  product: productReducer,
  inventory: inventoryReducer,
  challan: challanReducer,
  purchase: purchaseReducer,
  dealer: dealerReducer,
  quote: quoteReducer,
  country: countryReducer
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
})

export default store;